var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalcC(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_116_22084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12V24H4.5C2.01633 23.9962 0.00384375 21.9837 0 19.5V12H12Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12V19.5C23.9962 21.9837 21.9837 23.9962 19.5 24H12V12H24Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 4.5V12H12V0H19.5C21.9837 0.00384375 23.9962 2.01633 24 4.5Z",
    fill: "#DE513C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0V12H0V4.5C0.00384375 2.01633 2.01633 0.00384375 4.5 0H12Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50002 6.99998H3.50002C3.22388 6.99998 3 6.77611 3 6.49997C3 6.22383 3.22388 6 3.50002 6H9.50002C9.77616 6 10 6.22388 10 6.50002C10 6.77616 9.77616 6.99998 9.50002 6.99998Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.50002 9.99998C6.22388 9.99998 6 9.77611 6 9.49997V3.49997C6 3.22388 6.22388 3 6.50002 3C6.77616 3 7.00003 3.22388 7.00003 3.50002V9.50002C6.99998 9.77616 6.77616 9.99998 6.50002 9.99998Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.99998H15.5C15.2239 6.99998 15 6.77611 15 6.49997C15 6.22383 15.2239 6 15.5 6H20.5C20.7762 6 21 6.22388 21 6.50002C21 6.77616 20.7761 6.99998 20.5 6.99998Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49966 21.0001C8.34769 21.0005 8.20379 20.9317 8.10868 20.8132L4.10869 15.8131C3.9361 15.5975 3.97102 15.2828 4.18669 15.1102C4.40236 14.9376 4.71708 14.9725 4.88968 15.1882L8.88966 20.1882C9.06197 20.4039 9.02672 20.7186 8.81096 20.8909C8.72255 20.9615 8.61282 21 8.49966 21.0001Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5003 21.0002C4.22416 21.0003 4.00019 20.7766 4 20.5005C3.99995 20.387 4.03848 20.2769 4.10927 20.1882L8.10925 15.1882C8.28184 14.9725 8.59656 14.9376 8.81223 15.1102C9.02791 15.2828 9.06283 15.5975 8.89023 15.8131L4.8903 20.8132C4.79537 20.9314 4.65194 21.0002 4.5003 21.0002Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4998 21.0002C19.3241 21.0002 19.1612 20.908 19.0708 20.7572L16.0708 15.7572C15.9329 15.518 16.015 15.2122 16.2542 15.0742C16.4874 14.9398 16.7851 15.014 16.9279 15.2422L19.9279 20.2422C20.0704 20.4787 19.9941 20.786 19.7576 20.9285C19.6798 20.9753 19.5907 21.0001 19.4998 21.0002Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_116_22084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcC);
export default __webpack_public_path__ + "static/media/CalcC.54351c90b2abeca860c1025d6ebd5836.svg";
export { ForwardRef as ReactComponent };